import './response_attachment_view.js.coffee'

Namespace 'Customer.Ticket'

class Customer.Ticket.InstagramResponseAttachmentView extends Customer.Ticket.ResponseAttachmentView
  template: JST['backbone/templates/customer/ticket/attachment/instagram_response_attachment']
  className: 'instagram-response-attachment'

  initialize: (el, response, subtype) ->
    super(el, response, subtype)
    @MAX_BYTES_SIZE = 8388608
    @supportedMimeTypes = ['.jpg', '.jpeg', '.jpge', '.gif', '.bmp', '.ico', '.png']

  render: ->
    @$el.html(@template(allowedTypes: @supportedMimeTypes.join()))
    element = @$el.find('.file-upload-input')
    @appendFileUploadPlugin(element)

  _hasUnsupportedFile: =>
    @files.length && !@supportedMimeTypes.includes(".#{@files[0].file.type.split('/')[1]}")

  _hasInvalidSize: ->
    @files.length && @files[0].file.size > @MAX_BYTES_SIZE

  _showError: (message) ->
    return super(message) unless ['Unsuported type', 'Invalid type'].includes(message)

    @response._handleUnsupportedFormatError()
